module.exports = __webpack_public_path__ + "img/avions1.5685ac23.jpg";